import {  SeferPetachProvider         }       from "SeferPetach/SeferPetachProvider";
import {  BrowserRouter, 
          Route, 
          Routes                     }        from "react-router-dom";
import {  DefaultPage                }        from "Pages/Default/default_pg";
import    HomePage                            from "Pages/Home/home_pg";
import    Header                              from "components/Header/header";
import {  Layout                     }        from "Pages/Default/sys_pg";
import {  DynamicLayout              }        from "Pages/Default/dyn_pg";
import {  NotFound                   }        from "Pages/NotFound/notfound_pg";
import {  LoginPage                  }        from "Pages/Login/login_pg";
import {  UserConfigPage             }        from "Pages/UserConfig/user_config_pg";
import {  UserTagsPage               }        from "Pages/UserTags/user_tags_pg";
import {  MainContent                }        from "SeferPetach/staticContent";
import {  SectorPage                 }        from "Pages/Sector/sector_pg";
import {  CompanyPositionPage        }        from "Pages/CompanyPosition/company_position_pg";
import {  ProfilePhotoPage           }        from "Pages/ImageUser/image_user_pg";
import {  LogoPhotoPage              }        from "Pages/ImageLogo/image_logo_pg";
import {  FooterPhotoPage            }        from "Pages/ImageFooter/image_footer_pg";
import {  UsersPage                  }        from "Pages/Users/users_pg";
import {  TeachingStructurePage      }        from "Pages/TeachingStructure/teaching_structure_pg";
import {  OptionListPage             }        from "Pages/OptionLists/option_list_pg"; 
import {  ColorPage                  }        from "Pages/Colors/colors_pg";
import {  ImageResizerPage           }        from "Pages/ImageResizer/image_resizer_pg";
import {  QuestionPage               }        from "Pages/Question/question_pg";
import {  PatternPage                }        from "Pages/Pattern/pattern_pg";
import {  OrderManagementPage        }        from "Pages/Orders/Management/order_management_pg";
import {  OrderReadyPage             }        from "Pages/Orders/Ready/order_ready_pg";
import {  OrderPreviewPage           }        from "Pages/Orders/Preview/order_preview_pg";
import {  OrderDocumentPreviewPage   }        from "Pages/Orders/Preview/order_document_preview_pg";
import {  DesignationPage            }        from "Pages/Designation/designation_pg";
import {  SlideTemplatePage          }        from "Pages/SlideTemplate/slide_template_pg";
import {  OrderPreviewCodePage       }        from "Pages/Orders/Code/order_code_preview_pg";
import {  OrderCodePage              }        from "Pages/Orders/Code/order_code_pg";
import {  ClosedOrderPage            }        from "Pages/Orders/Closed/order_closed_pg";
import {  FormOutOfPeriod, 
          FormNotFound               }        from "Pages/Orders/Error/order_error_pg";
import {  OrderReportPage            }        from "Pages/Orders/Finished/order_finished_pg";
import {  Report_0_Page              }        from "Pages/Reports/Report_0/report_0_pg";
import {  Report_1_Page              }        from "Pages/Reports/Report_1/report_1_pg";
import {  Report_2_Page              }        from "Pages/Reports/Report_2/report_2_pg";
import {  Report_3_Page              }        from "Pages/Reports/Report_3/report_3_pg";
import {  Report_4_Page              }        from "Pages/Reports/Report_4/report_4_pg";
import {  Report_5_Page              }        from "Pages/Reports/Report_5/report_5_pg";
import {  Report_6_Page              }        from "Pages/Reports/Report_6/report_6_pg";
import {  GamePlayer, 
          Credits, 
          GetHelp                    }        from "Pages/DevArea/fun";


function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<DefaultPage/>}>
          <Route index  element={<><Header /><HomePage/></>}/>
          <Route path="login" element={<><Header /><LoginPage/></>}/>
          <Route path="home" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <MainContent/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="user_config" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <UserConfigPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="user_tags" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <UserTagsPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="sectors" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <SectorPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="company_position" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <CompanyPositionPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="designation" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <DesignationPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="profile_photo" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <ProfilePhotoPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="logos" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <LogoPhotoPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="image_resizer" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <ImageResizerPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="footers" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <FooterPhotoPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="slides" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <SlideTemplatePage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="colors" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <ColorPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="users" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <UsersPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="teaching_structure" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <TeachingStructurePage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="option_lists" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <OptionListPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="questions" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <QuestionPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="patterns" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <PatternPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="orders" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <OrderManagementPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="order/:orderId/p" element={
                                        <SeferPetachProvider>
                                          <DynamicLayout>
                                            <OrderPreviewPage return_path={"/orders"}/>
                                          </DynamicLayout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="order/:orderId/p/d" element={
                                        <SeferPetachProvider>
                                          <DynamicLayout>
                                            <OrderDocumentPreviewPage return_path={"/orders"}/>
                                          </DynamicLayout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="orders_ready" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <OrderReadyPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="orders_ready/:orderId/p" element={
                                        <SeferPetachProvider>
                                          <DynamicLayout>
                                            <OrderPreviewPage return_path={"/orders_ready"}/>
                                          </DynamicLayout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="s/:orderCode/p" element={
                                        <SeferPetachProvider>
                                          <DynamicLayout>
                                            <OrderPreviewCodePage return_path={"/orders_ready"}/>
                                          </DynamicLayout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="s/:orderCode" element={
                                        <DynamicLayout>
                                          <OrderCodePage/>
                                        </DynamicLayout>
                                      }
          />
          <Route path="orders_ready/:orderId/f" element={
                                        <SeferPetachProvider>
                                          <DynamicLayout>
                                            <OrderReportPage return_path={"/orders_ready"}/>
                                          </DynamicLayout>
                                        </SeferPetachProvider>
                                                }
          />
          <Route path="orders_closed" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <ClosedOrderPage/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />
          <Route path="report_0" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Report_0_Page/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />
          <Route path="tag/:tagId" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Report_1_Page/>
                                          </Layout>
                                        </SeferPetachProvider>
                                      }
          />
          <Route path="report_1" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Report_2_Page/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />                        
          <Route path="report_2" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Report_3_Page/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />      
          <Route path="report_3" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Report_4_Page/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />
          <Route path="report_4" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Report_5_Page/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />
          <Route path="report_6" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Report_6_Page/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />                    
          <Route path="help" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <GetHelp/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />                 
          <Route path="dev_area" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <GamePlayer/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />
          <Route path="credits" element={
                                        <SeferPetachProvider>
                                          <Layout>
                                            <Credits/>
                                          </Layout>
                                        </SeferPetachProvider>
                                                }
          />                  
          <Route path="out_of_period" element={<FormOutOfPeriod/>}/>
          <Route path="not_found" element={<FormNotFound/>}/>
          <Route path="*" element={<NotFound/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
export default App;